import React, { Component } from "react";
import { connect } from "react-redux";
import AddFileByDrag from "./children/addFileByDrag/AddFileByDrag";
import AddFileByUrl from "./children/addFileByUrl/AddFileByUrl";
import "../../assets/upload.less";

class Upload extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="Upload" style={!this.props.visible ? { display: "none" } : {}}>
        <AddFileByDrag
          size={this.props.size}
          type={this.props.type}
          theme={this.props.theme}
          isUploadPreload={this.props.isUploadPreload}
          isPreloadBlob={this.props.isPreloadBlob}
          isCropPreload={this.props.isCropPreload}
          isShowUploadProcess={this.props.isShowUploadProcess}
          hideCancelText={this.props.hideCancelText}
          showProcessText={this.props.showProcessText}
          accept={this.props.accept}
          work={this.props.work}
          uploadBtnText={this.props.uploadBtnText}
          uploadNoteText={this.props.uploadNoteText}
          uploadHasEmailCallback={this.props.uploadHasEmailCallback}
          addFileCallBack={this.props.addFileCallBack}
          uploadMaxCount={this.props.uploadMaxCount || 1}
          isHideUploadProcessCont={this.props.isHideUploadProcessCont}
        />
        {this.props.addFileByUrlVisible ? (
          <AddFileByUrl work={this.props.work} theme={this.props.theme} addFileCallBack={this.props.addFileCallBack} />
        ) : null}
      </div>
    );
  }
}
const mapStateToPropos = state => ({
  work: state.work.work,
});
export default connect(mapStateToPropos)(Upload);
